import { createContext, useContext, useReducer } from "react";

export const ChatContext = createContext({});

export const ChatContextProvider = ({ children }) => {
 
  const INITIAL_STATE = {
    chatName: "",
    categoryId: 1, 
    currentChat: {}
  };

 const chatReducer = (state, action) => { 
  switch (action.type) {
    case "SET_NAME":
      return { 
        ...state,
        chatName:  action.payload
      }; 
    case "SET_CATEGORY":
      return { 
        ...state,
        categoryId:  action.payload
      }; 
    case "SET_CHAT":
      return { 
        ...state,
        currentChat:  action.payload
      };
    default:
      return state;
  }
};

  const [state, dispatch] = useReducer(chatReducer, INITIAL_STATE);

  return (
    <ChatContext.Provider value={{ data: state, dispatch }}>
      {children}
    </ChatContext.Provider>
  );
};
